import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "seg-vista" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = { class: "subtitulo" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = {
  key: 0,
  class: "estado-msg"
}
const _hoisted_6 = {
  key: 1,
  class: "estado-msg error"
}
const _hoisted_7 = { class: "acciones-top" }
const _hoisted_8 = {
  key: 0,
  class: "ok-msg"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "bloque" }
const _hoisted_12 = { class: "grid-portada" }
const _hoisted_13 = { class: "nota" }
const _hoisted_14 = { class: "bloque" }
const _hoisted_15 = { class: "bloque" }
const _hoisted_16 = { class: "bloque" }
const _hoisted_17 = {
  key: 0,
  class: "nota"
}
const _hoisted_18 = { class: "contenedor-tabla" }
const _hoisted_19 = { class: "lista-tabla" }
const _hoisted_20 = { class: "ctr" }
const _hoisted_21 = { class: "ctr" }
const _hoisted_22 = { class: "bloque" }
const _hoisted_23 = { class: "resumen-linea" }
const _hoisted_24 = { class: "nota" }

import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import {
  getSeguimientoPlanService,
  guardarSeguimientoPlanService,
  descargarPdfSeguimientoService,
  type SeguimientoPlan,
  type TipoSeguimiento,
  type SeguimientoEditable
} from '@/services/SeguimientoPlanService'


export default /*@__PURE__*/_defineComponent({
  __name: 'SeguimientoPlanView',
  setup(__props) {

/**
 * Seguimiento periódico del plan de mejoramiento.
 *
 * La alerta C6 avisa de los planes con acciones abiertas y sin seguimiento en 90
 * días.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)

const tipo = ref<TipoSeguimiento>('mejoramiento')
const datos = ref<SeguimientoPlan | null>(null)
const cargando = ref(false)
const error = ref('')
const guardando = ref(false)
const guardadoOk = ref(false)
const descargando = ref(false)

const ed = reactive<SeguimientoEditable>({})

function fmt(d: string | null): string {
  if (!d) return ''
  const p = new Date(d)
  return isNaN(p.getTime()) ? '' : p.toLocaleDateString('es-CO')
}
function rango(i: string | null, f: string | null): string {
  return i || f ? `${fmt(i)} – ${fmt(f)}`.trim() : ''
}
function pillClase(v: number | null): string {
  if (v === null) return 'p-gris'
  return v >= 70 ? 'p-verde' : v >= 40 ? 'p-ambar' : 'p-rojo'
}

const valoracionPreview = computed(() => {
  if (!datos.value) return ''
  return (ed.valoracion_final ?? '')
    .replace(/\{promedio\}/g, String(datos.value.resumen.promedio))
    .replace(/\{aspectos\}/g, String(datos.value.resumen.n_aspectos))
})

async function cargar(): Promise<void> {
  cargando.value = true
  error.value = ''
  const r = await getSeguimientoPlanService(idEjecucion, tipo.value)
  if (r.ok && r.data) {
    datos.value = r.data
    ed.anexo = r.data.portada.anexo
    ed.condicion = r.data.portada.condicion
    ed.codigo_snies = r.data.portada.codigo_snies
    ed.resolucion = r.data.portada.resolucion
    ed.lugar = r.data.portada.lugar
    ed.fecha_elaboracion = r.data.portada.fecha_elaboracion
    ed.presentacion = r.data.narrativa.presentacion
    ed.informe_intro = r.data.narrativa.informe_intro
    ed.valoracion_final = r.data.narrativa.valoracion_final
  } else {
    error.value = r.error ?? 'No se pudo cargar'
    datos.value = null
  }
  cargando.value = false
}

function cambiarTipo(t: TipoSeguimiento): void {
  if (tipo.value === t) return
  tipo.value = t
  cargar()
}

async function guardar(): Promise<void> {
  guardando.value = true
  guardadoOk.value = false
  const r = await guardarSeguimientoPlanService(idEjecucion, tipo.value, { ...ed })
  guardando.value = false
  if (r.ok) {
    guardadoOk.value = true
    setTimeout(() => (guardadoOk.value = false), 2500)
  } else {
    error.value = r.error ?? 'No se pudo guardar'
  }
}

async function descargar(): Promise<void> {
  descargando.value = true
  await descargarPdfSeguimientoService(idEjecucion, tipo.value)
  descargando.value = false
}

onMounted(cargar)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Informe de Seguimiento al Plan", -1)),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode("Ejecución #" + _toDisplayString(_unref(idEjecucion)), 1),
          (datos.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · " + _toDisplayString(datos.value.portada.programa) + " · " + _toDisplayString(datos.value.portada.periodo), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
      }, "Volver")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass(["tab", { activo: tipo.value === 'mejoramiento' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (cambiarTipo('mejoramiento')))
      }, "Plan de Mejoramiento", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["tab", { activo: tipo.value === 'fortalecimiento' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (cambiarTipo('fortalecimiento')))
      }, "Plan de Fortalecimiento", 2)
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Cargando…"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
        : (datos.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_7, [
                (guardadoOk.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Cambios guardados ✓"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn",
                  disabled: guardando.value,
                  onClick: guardar
                }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar cambios'), 9, _hoisted_9),
                _createElementVNode("button", {
                  class: "btn primario",
                  disabled: descargando.value,
                  onClick: descargar
                }, _toDisplayString(descargando.value ? 'Generando…' : 'Descargar PDF'), 9, _hoisted_10)
              ]),
              _createElementVNode("section", _hoisted_11, [
                _cache[20] || (_cache[20] = _createElementVNode("h2", null, "1 · Portada", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", null, [
                    _cache[13] || (_cache[13] = _createTextVNode("Anexo")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ed.anexo) = $event)),
                      type: "text",
                      placeholder: "ANEXO 2."
                    }, null, 512), [
                      [_vModelText, ed.anexo]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[14] || (_cache[14] = _createTextVNode("Condición")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ed.condicion) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, ed.condicion]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[15] || (_cache[15] = _createTextVNode("Código SNIES")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ed.codigo_snies) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, ed.codigo_snies]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[16] || (_cache[16] = _createTextVNode("Resolución")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ed.resolucion) = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, ed.resolucion]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[17] || (_cache[17] = _createTextVNode("Lugar")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ed.lugar) = $event)),
                      type: "text",
                      placeholder: "Bucaramanga"
                    }, null, 512), [
                      [_vModelText, ed.lugar]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[18] || (_cache[18] = _createTextVNode("Fecha de elaboración")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ed.fecha_elaboracion) = $event)),
                      type: "date"
                    }, null, 512), [
                      [_vModelText, ed.fecha_elaboracion]
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _cache[19] || (_cache[19] = _createTextVNode("Título del documento: ")),
                  _createElementVNode("b", null, _toDisplayString(datos.value.portada.titulo), 1),
                  _createTextVNode(" · Facultad: " + _toDisplayString(datos.value.portada.facultad ?? '—'), 1)
                ])
              ]),
              _createElementVNode("section", _hoisted_14, [
                _cache[21] || (_cache[21] = _createElementVNode("h2", null, "2 · Presentación", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ed.presentacion) = $event)),
                  rows: "5"
                }, null, 512), [
                  [_vModelText, ed.presentacion]
                ])
              ]),
              _createElementVNode("section", _hoisted_15, [
                _cache[22] || (_cache[22] = _createElementVNode("h2", null, "3 · Informe de seguimiento", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ed.informe_intro) = $event)),
                  rows: "4"
                }, null, 512), [
                  [_vModelText, ed.informe_intro]
                ])
              ]),
              _createElementVNode("section", _hoisted_16, [
                _cache[27] || (_cache[27] = _createElementVNode("h2", null, "4 · Seguimiento por factor", -1)),
                (datos.value.sin_plan || !datos.value.factores.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                      _createTextVNode(" La ejecución no tiene un plan de " + _toDisplayString(tipo.value) + " con acciones. Genera y diligencia el ", 1),
                      _createVNode(_component_router_link, {
                        to: { name: 'PlanMejoramiento', params: { id_ejecucion: _unref(idEjecucion) } }
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("plan de mejoramiento")
                        ])),
                        _: 1,
                        __: [23]
                      }, 8, ["to"]),
                      _cache[24] || (_cache[24] = _createTextVNode(" primero. "))
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[26] || (_cache[26] = _createElementVNode("p", { class: "nota" }, "Los datos de estas tablas se toman del plan; edítalos en el plan de mejoramiento (aspecto, meta, estrategias, balance de cumplimiento).", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value.factores, (f) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: f.factor,
                          class: "factor"
                        }, [
                          _createElementVNode("h3", null, _toDisplayString(f.factor), 1),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("table", _hoisted_19, [
                              _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "Aspecto por mejorar"),
                                  _createElementVNode("th", null, "Meta trazada"),
                                  _createElementVNode("th", null, "Medición"),
                                  _createElementVNode("th", null, "Por cumplir"),
                                  _createElementVNode("th", null, "Periodo"),
                                  _createElementVNode("th", null, "Estrategias implementadas"),
                                  _createElementVNode("th", { class: "ctr" }, "Balance")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.filas, (fila) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: fila.id_accion
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(fila.aspecto), 1),
                                    _createElementVNode("td", null, _toDisplayString(fila.meta), 1),
                                    _createElementVNode("td", null, _toDisplayString(fila.medicion), 1),
                                    _createElementVNode("td", null, _toDisplayString(fila.por_cumplir), 1),
                                    _createElementVNode("td", _hoisted_20, _toDisplayString(rango(fila.fecha_inicio, fila.fecha_terminacion)), 1),
                                    _createElementVNode("td", null, _toDisplayString(fila.estrategias), 1),
                                    _createElementVNode("td", _hoisted_21, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["pill", pillClase(fila.balance)])
                                      }, _toDisplayString(fila.balance === null ? '—' : fila.balance + '%'), 3)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ], 64))
              ]),
              _createElementVNode("section", _hoisted_22, [
                _cache[30] || (_cache[30] = _createElementVNode("h2", null, "5 · Valoración final", -1)),
                _createElementVNode("p", _hoisted_23, [
                  _cache[28] || (_cache[28] = _createTextVNode(" Cumplimiento promedio: ")),
                  _createElementVNode("b", null, _toDisplayString(datos.value.resumen.promedio) + "%", 1),
                  _createTextVNode(" · " + _toDisplayString(datos.value.resumen.n_aspectos) + " aspecto(s). ", 1),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "nota" }, [
                    _createTextVNode("Usa "),
                    _createElementVNode("code", null, "{promedio}"),
                    _createTextVNode(" y "),
                    _createElementVNode("code", null, "{aspectos}"),
                    _createTextVNode(" como comodines en el texto.")
                  ], -1))
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((ed.valoracion_final) = $event)),
                  rows: "5"
                }, null, 512), [
                  [_vModelText, ed.valoracion_final]
                ]),
                _createElementVNode("p", _hoisted_24, "Vista previa: " + _toDisplayString(valoracionPreview.value), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})